import { createIcon } from "@chakra-ui/react";

export const DownloadCloud = createIcon({
  displayName: "DownloadCloud",
  viewBox: "0 0 24 24",
  d: "M13.309 6.064c.517.6 1.369.791 2.096.469a2.698 2.698 0 0 1 3.761 2.906 1.805 1.805 0 0 0 1.054 1.938 3.297 3.297 0 0 1-1.125 6.315.464.464 0 0 0-.071.008H5.4a3.6 3.6 0 0 1-1.2-6.994 1.8 1.8 0 0 0 1.2-1.698V9a4.499 4.499 0 0 1 7.909-2.936zM19.2 19.5v-.008a5.104 5.104 0 0 0 1.744-9.769C20.98 9.489 21 9.244 21 9a4.499 4.499 0 0 0-6.326-4.114A6.293 6.293 0 0 0 9.9 2.7 6.3 6.3 0 0 0 3.6 9v.008A5.401 5.401 0 0 0 5.4 19.5h13.8zM8.363 13.238l3 3a.896.896 0 0 0 1.27 0l3-3a.9.9 0 0 0-1.271-1.271L12.9 13.428V8.4c0-.499-.401-.9-.9-.9s-.9.401-.9.9v5.029l-1.463-1.463a.9.9 0 0 0-1.271 1.271h-.004z",
  defaultProps: {
    "aria-label": "Download icon: An arrow pointing down within a hollow cloud"
  }
});

export default DownloadCloud;
